<template>
  <div class="page-container">
    <el-card>
      <div class="text-right mb-20">
        <el-button size="mini" type="primary" @click="add">新增</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :get-data="getMenuList"
        :is-current-page="false"
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :close-on-click-modal="false"
      width="500px"
    >
      <app-form
        v-if="dialog_config.is_show"
        :form-data="dialog_config.form_config"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { formDataAssign } from '@/tools/form';
import { clone, flattenObjArray } from '@/utils';
import PermissionsResource from '@/api/permissions';
const permissionsResource = new PermissionsResource();

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      form_config: require('./model/form-config.js')(this),
      dialog_config: {
        is_show: false,
        title: '新增',
        form_config: {},
        confirm: () => {},
      },
      /** 扁平化后的菜单数据 */
      flatten_menu_list: [],
    };
  },
  methods: {
    getMenuList() {
      return new Promise((resolve, reject) => {
        permissionsResource.getApi().then(({ menu: { list }}) => {
          resolve(list);
          // 更新表格时同步最新的菜单数据
          this.form_config.parent_id.options = list;
          this.flatten_menu_list = flattenObjArray(JSON.parse(JSON.stringify(list)));
        }).catch(reject);
      });
    },
    add() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新增',
        form_config: clone(this.form_config),
        confirm: (params) => {
          const { menu_permission } = params;
          if (this.getMenuByPermission(menu_permission)) {
            this.$message.warning('该权限值已存在，请输入新的权限值！');
            return;
          }
          permissionsResource.addApi({ ...params, is_menu: 1 }).then(() => {
            this.$message.success('新增成功！');
            this.$refs.table.refer();
            this.dialog_config.is_show = false;
          });
        },
      });
    },
    edit(row) {
      const { id } = row;
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '编辑',
        form_config: clone(this.form_config),
        confirm: (params) => {
          const { parent_id, menu_permission } = params;
          const menu_item = this.getMenuByPermission(menu_permission);
          if (menu_item && menu_item.id !== id) {
            this.$message.warning('该权限值已存在，请输入新的权限值！');
            return;
          }
          if (id === parent_id) {
            this.$message.warning('无效父级，请重新选择！');
            return;
          }
          permissionsResource.editApi({ ...params, is_menu: 1 }, id).then(() => {
            this.$message.success('编辑成功！');
            this.$refs.table.refer();
            this.dialog_config.is_show = false;
          });
        },
      });
      formDataAssign(this.dialog_config.form_config, row);
    },
    onParentIdChange(value) {
      // value 为null即为清空动作、重置parent_id：0
      if (value === null) {
        this.dialog_config.form_config['parent_id'].value = 0;
      }
    },
    /**
     * 通过权限值获取对应的菜单项
     * @param {string} permission 权限值
     * @returns {(Object|undefined)} 菜单项或undefined
     */
    getMenuByPermission(permission) {
      return this.flatten_menu_list.find(m => m.menu_permission === permission);
    },
  },
};
</script>
